module.exports = __webpack_public_path__ + "static/media/08.17eab135.png";